import React from 'react'

import LayoutAuth from 'components/layouts/LayoutAuth'
import TemplateLogin from 'components/templates/TemplateLogin'
import {TPageComponent} from 'src/types'

interface ILoginProps {}

const Login: TPageComponent<ILoginProps> = () => {
	return <TemplateLogin />
}

Login.displayName = 'Login'

Login.Layout = LayoutAuth

export default Login
